// JsFromRoutes CacheKey 6d65a7895c75dd788138fefc2133bd33
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  index: /* #__PURE__ */ definePathHelper('get', '/admin/notifications'),
}
